/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OccurrenceProbabilityLevelDto } from '../../models/occurrence-probability-level-dto';

export interface GetAllOccurrenceProbabilityLevels$Params {
}

export function getAllOccurrenceProbabilityLevels(http: HttpClient, rootUrl: string, params?: GetAllOccurrenceProbabilityLevels$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<OccurrenceProbabilityLevelDto>>> {
  const rb = new RequestBuilder(rootUrl, getAllOccurrenceProbabilityLevels.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<OccurrenceProbabilityLevelDto>>;
    })
  );
}

getAllOccurrenceProbabilityLevels.PATH = '/occurrence-probability-levels';
